// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Comment Lines
// MODIFIED DATE: 18-08-2025
import CloseLoanActionTypes from './close-loan.types';

/** ***************** GET CLOSE LOAN START *********************** */
export const getCloseLoanDetailsStart = (getData: any) => ({
	type: CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_START,
	payload: getData,
});

export const getCloseLoanDetailsSuccess = (successData: any) => ({
	type: CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const getCloseLoanDetailsFailure = (failureData: any) => ({
	type: CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const getCloseLoanDetailsResponseResetStart = () => ({
	type: CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_RESPONSE_RESET,
});

export const getCloseLoanDetailsResponseChanged = () => ({
	type: CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET CLOSE LOAN END *********************** */

/** ***************** UPDATE CLOSE LOAN START *********************** */
export const updateCloseLoanDetailsStart = (getData: any) => ({
	type: CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_START,
	payload: getData,
});

export const updateCloseLoanDetailsSuccess = (successData: any) => ({
	type: CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const updateCloseLoanDetailsFailure = (failureData: any) => ({
	type: CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const updateCloseLoanDetailsResponseResetStart = () => ({
	type: CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_RESPONSE_RESET,
});

export const updateCloseLoanDetailsResponseChanged = () => ({
	type: CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** UPDATE CLOSE LOAN END *********************** */

/** ***************** REVERT CLOSE LOAN START *********************** */
export const revertCloseLoanDetailsStart = (getData: any) => ({
	type: CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_START,
	payload: getData,
});

export const revertCloseLoanDetailsSuccess = (successData: any) => ({
	type: CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const revertCloseLoanDetailsFailure = (failureData: any) => ({
	type: CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const revertCloseLoanDetailsResponseResetStart = () => ({
	type: CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_RESPONSE_RESET,
});

export const revertCloseLoanDetailsResponseChanged = () => ({
	type: CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** REVERT CLOSE LOAN END *********************** */
